import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class CartaoService extends BaseService {
  getCarteirinhas(carteirinhas: any) {
    const url = `${environment.portalApi}/Health/DownloadMultiplasCarteirinhas?` + carteirinhas;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
  getCarteirinha(url: any) {
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
}
